const parseFlag = (
  value: string | undefined,
  defaultValue = false,
): boolean => {
  if (value === undefined) {
    return defaultValue;
  }

  return value.trim().toLowerCase() === "true";
};

export const publicFeatureFlags = {
  formattedCopyEnabled: parseFlag(
    import.meta.env.VITE_FORMATTED_COPY_ENABLED,
    true,
  ),
} as const;
